/*
  Shared visual language for the text-entry controls (input, textarea).

  `focus:` and not `focus-visible:`, unlike the ring on buttons and links. A
  text field should look focused however the caret got there — clicking into
  one and seeing no change reads as broken. Browsers agree: `:focus-visible`
  matches text fields on mouse click anyway, so the distinction would be moot
  here even if it were wanted.
*/
export const FIELD =
  'w-full appearance-none rounded-sm border-2 border-solid border-form-input-border px-4 ' +
  'text-base font-medium tracking-[0.02em] text-type-black font-[inherit] ' +
  'm-0 shadow-none outline-0 transition-[border-color] duration-200 ease-[ease] ' +
  'focus:border-form-input-active active:border-form-input-active ' +
  'read-only:border-form-input-readonly-border read-only:bg-form-input-readonly-bg read-only:text-form-input-active';
